import { render, staticRenderFns } from "./DefaultSchema.vue?vue&type=template&id=66e10ae0&"
import script from "./DefaultSchema.vue?vue&type=script&lang=ts&"
export * from "./DefaultSchema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports